// React
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injection
import { notifyError } from '../../containers/componentsInjection';
import { ReportsInjection } from '../../containers/reportsInjection';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { createData } from '../../../../utils/createData';
import { APIClient } from '../../../../helpers/api_helper';

// View
import { FinancialPayrollDiscountPage } from './view';

export const FinancialPayrollDiscount = () => {
  const [statusOptions, setStatusOptions] = useState([]);
  const [defaultInstructions, setDefaultInstructions] = useState('');

  const { organizations, getOrganizations } = ReportsInjection();
  const [payrollData, setPayrollData] = useState(null);

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  const getProposalStatus = async () => {
    await api.get('/proposal/get-status').then((status) => {
      setStatusOptions(createData(status));
    });
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      periodStarts: '',
      periodEnds: '',
      organizationInput: null,
      proposalSituationInput: '',
      statusType: 'add',
      periodType: 'sale',
      instructions: defaultInstructions,
    },
    validationSchema: Yup.object({
      periodStarts: Yup.string(),
      periodEnds: Yup.string(),
      periodType: Yup.string(),
      organizationInput: Yup.array().of(
        Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .required()
      ),
      proposalSituationInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string().required(),
      }),
      statusType: Yup.string(),
      instructions: Yup.string(),
    }),

    onSubmit: (values) => {
      let organizationsArray = values.organizationInput.map((item) => {
        return item.value;
      });

      const valuesToSubmit = {
        starts: values.periodStarts || null,
        ends: values.periodEnds || null,
        organization_id: organizationsArray || null,
        proposal_status_id: values.proposalSituationInput.value || null,
        status: values.statusType || null,
        periodType: values.statusType === 'remove' ? null : values.periodType,
      };

      toggleLoading();
      api
        .create('/reports/financial/payroll-discount-search', valuesToSubmit)
        .then((response) => {
          const data = response;
          // console.log(data, 'Desconto em Folha');
          setPayrollData(data);
        })
        .catch((error) => {
          notifyError(error.response.data.messages.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    getOrganizations();
    getProposalStatus();
  }, []);

  useEffect(() => {
    const loadTextFile = async () => {
      try {
        const response = await fetch('/instructions.txt');
        const text = await response.text();
        setDefaultInstructions(text);
      } catch (error) {
        console.error('erro ao carregar o arquivo de texto:', error);
      }
    };

    loadTextFile();
  }, []);

  return (
    <>
      <FinancialPayrollDiscountPage
        history={history}
        createData={createData}
        organizations={organizations || []}
        statusOptions={statusOptions || []}
        payrollData={payrollData || []}
        validation={validation}
      />
    </>
  );
};
